/* eslint-disable react/no-array-index-key */

import React from 'react';
import type { ProductVariantsPdpModel, VariantPickerListItem, VariantSectionModel } from 'autogen/swagger/all';
import ChanelProductVariantsComponent from 'components/chanel/ChanelProductVariants';
import type { ChanelProductVariants, Option } from 'components/chanel/ChanelProductVariants/shared/types';

function chanelMapper(section: VariantSectionModel): ChanelProductVariants {
    return {
        displayColorSwatches: section.variants.some((x) => x.colors.length),
        options: section.variants.map(
            (x: VariantPickerListItem): Option => ({
                color: x.colors[0],
                label: x.name,
                linkAction: x.linkAction,
                isSelected: x.isSelected
            })
        )
    };
}

export default function ProductVariantsMapped({ model, ...restProps }: { model: ProductVariantsPdpModel }) {
    return (
        <>
            {model.sections.map((section, index) => (
                <ChanelProductVariantsComponent key={index} {...chanelMapper(section)} {...restProps} />
            ))}
        </>
    );
}
